// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__Q07-B {
  margin: 120rem auto 68rem;
  width: 100%;
  padding: 0 48px;
}
@media (min-width: 1825px) {
  .style_container__Q07-B {
    width: 1856px;
  }
}
@media only screen and (max-width: 700px) {
  .style_container__Q07-B {
    padding: 0 16rem;
  }
}
@media only screen and (max-width: 700px) {
  .style_container__Q07-B {
    margin: 68rem auto 32rem;
  }
}

.style_title__J-xgU {
  display: inline;
  gap: 24rem;
  font-family: "Vivl Rail", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 72rem;
  line-height: 82rem;
  color: #1d2939;
}
.style_title__J-xgU img {
  height: 68rem;
  width: 68rem;
  margin-right: 12rem;
}
@media only screen and (max-width: 700px) {
  .style_title__J-xgU img {
    height: 42rem;
    width: 42rem;
  }
}
@media only screen and (max-width: 700px) {
  .style_title__J-xgU {
    font-family: "Vivl Rail", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 32rem;
    line-height: 42rem;
    color: #1d2939;
  }
}

.style_content__T6BSg {
  display: flex;
  align-items: center;
  gap: 32rem;
  margin-top: 32px;
}
@media only screen and (max-width: 700px) {
  .style_content__T6BSg {
    flex-direction: column;
  }
}

.style_text__n\\+4da {
  display: flex;
  flex-direction: column;
  gap: 42rem;
}
.style_text__n\\+4da * {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24rem;
  line-height: 32rem;
  color: #101828;
}
.style_text__n\\+4da strong, .style_text__n\\+4da b {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24rem;
  line-height: 32rem;
  color: #101828;
}
@media only screen and (max-width: 700px) {
  .style_text__n\\+4da * {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 24rem;
    color: #101828;
  }
  .style_text__n\\+4da strong, .style_text__n\\+4da b {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16rem;
    line-height: 24rem;
    color: #101828;
  }
}

.style_image__rZC0D {
  width: 900rem;
  height: 506rem;
  object-fit: cover;
  object-position: center;
  border-radius: 8rem;
  flex: none;
}
@media only screen and (max-width: 700px) {
  .style_image__rZC0D {
    width: 100%;
    height: auto;
    aspect-ratio: 900/506;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MainActivity/styles/style.module.scss","webpack://./src/styles/_mixins.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGA;EC4BE,yBD3BmB;EC4BnB,WAAA;EACA,eAAA;AD7BF;AC8BE;ED/BF;ICgCI,aAAA;ED3BF;AACF;ACiIE;EDvIF;ICoCI,gBAAA;ED1BF;AACF;AC4HE;EDvIF;IAGI,wBAAA;EAYF;AACF;;AATA;ECgDE,eAAA;EACA,UAAA;EAxDA,oCCHW;EDIX,kBAAA;EACA,gBAkEgC;EAjEhC,gBAAA;EACA,kBAAA;EACA,cCKS;AFiBX;AC+BE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AD7BJ;ACuGE;EA7EA;IAKI,aAAA;IACA,YAAA;ED3BJ;AACF;ACiGE;EDhIF;ICPE,oCCHW;IDIX,kBAAA;IACA,gBAoEkC;IAnElC,gBAAA;IACA,kBAAA;IACA,cCKS;EFqCT;AACF;;AArCA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AAwCF;ACgFE;ED5HF;IAMI,sBAAA;EA0CF;AACF;;AAvCA;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AA0CF;AAxCE;EC1BA,iCCFU;EDGV,kBAAA;EACA,gBAH0D;EAI1D,gBAAA;EACA,kBAAA;EACA,cCMS;AF+DX;AA7CE;EC7BA,iCCFU;EDGV,kBAAA;EACA,gBD4BkC;EC3BlC,gBAAA;EACA,kBAAA;EACA,cCMS;AFuEX;ACqDE;EDrGE;IClCF,iCCFU;IDGV,kBAAA;IACA,gBAH0D;IAI1D,gBAAA;IACA,kBAAA;IACA,cCMS;EFgFT;EAtDE;ICrCF,iCCFU;IDGV,kBAAA;IACA,gBDoCoC;ICnCpC,gBAAA;IACA,kBAAA;IACA,cCMS;EFwFT;AACF;;AAzDA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AA4DF;AC0BE;ED5FF;IAQI,WAAA;IACA,YAAA;IACA,qBAAA;EA8DF;AACF","sourcesContent":["@use \"/src/styles/mixins\" as *;\n@use \"/src/styles/variables\" as *;\n\n.container {\n  @include container(120rem auto 68rem);\n  @include mobile {\n    margin: 68rem auto  32rem;\n  }\n}\n\n.title {\n  @include sectionHeader;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  gap: 32rem;\n  margin-top: 32px;\n  @include mobile {\n    flex-direction: column;\n  }\n}\n\n.text {\n  display: flex;\n  flex-direction: column;\n  gap: 42rem;\n\n  & * {\n    @include fnt(24, 32, $gray-900);\n  }\n  strong, b {\n    @include fnt(24, 32, $gray-900, 600);\n  }\n\n  @include mobile {\n    & * {\n      @include fnt(16, 24, $gray-900);\n    }\n    strong, b {\n      @include fnt(16, 24, $gray-900, 600);\n    }\n  }\n}\n\n.image {\n  width: 900rem;\n  height: 506rem;\n  object-fit: cover;\n  object-position: center;\n  border-radius: 8rem;\n  flex: none;\n  @include mobile {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 900 / 506;\n  }\n}","@use \"variables\" as *;\n\n@mixin fnt($size: 16, $height: 24, $color: $black, $weight: 400, $font: $font-text, $unit: \"rem\") {\n  font-family: $font;\n  font-style: normal;\n  font-weight: $weight;\n  font-size: #{$size}#{$unit};\n  line-height: #{$height}#{$unit};\n  color: $color;\n}\n\n@mixin scrollable {\n  display: flex;\n  overflow-x: auto;\n\n  gap: 24rem;\n  margin-top: 32rem;\n  padding: 0 48rem;\n\n  @media(min-width: #{$main-container + 1}px) {\n    padding: 0 calc((100vw - #{$main-container}px) / 2);\n  }\n\n  @include mobile {\n    margin-top: 16rem;\n    gap: 16rem;\n    padding: 0 16rem;\n  }\n}\n\n@mixin container($margin: 124rem auto) {\n  margin: $margin;\n  width: 100%;\n  padding: 0 48px;\n  @media (min-width: #{$main-container + 1}px) {\n    width: #{$main-container + 32}px;\n\n  }\n  @include mobile {\n    padding: 0 16rem;\n  }\n}\n\n@mixin scrollButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: end;\n  height: fit-content;\n  width: fit-content;\n  gap: 16rem;\n\n  @include mobile {\n    display: none;\n  }\n}\n\n@mixin sectionHeader {\n  display: inline;\n  gap: 24rem;\n\n  img {\n    height: 68rem;\n    width: 68rem;\n    margin-right: 12rem;\n    @include mobile {\n      height: 42rem;\n      width: 42rem;\n    }\n  }\n\n  @include fnt(72, 82, $gray-800, 400, $font-title);\n  @include mobile {\n    @include fnt(32, 42, $gray-800, 400, $font-title);\n  }\n}\n\n@mixin header {\n  width: 100%;\n  padding: 0 48rem;\n  height: fit-content;\n  @include sectionHeader;\n  @include mobile {\n    padding: 0 16rem;\n  }\n  @content\n}\n\n@mixin textToMobile {\n  @include fnt(20, 24, $gray-400, 400, $font-text);\n  @include mobile {\n    @include fnt(16, 20, $gray-400, 400, $font-text);\n  }\n}\n\n@mixin inputField {\n  border-radius: 12rem;\n  padding: 16rem 20rem;\n\n  background-color: $white;\n  border: 1px $gray-300 solid;\n\n  @include mobile {\n    padding: 12rem 16rem;\n  }\n\n  @include textToMobile;\n\n  &::placeholder {\n    @include textToMobile;\n  }\n\n  * {\n    @include textToMobile;\n  }\n\n  &:active {\n    border: 1px $gray-700, solid;\n  }\n\n  &:hover {\n    border: 1px $gray-400, solid;\n  }\n\n  &error {\n    @include fnt(16, 24, $error-300, 500, $font-text);\n    @include mobile {\n      @include fnt(12, 24, $error-300, 500, $font-text);\n    }\n    border: 1px $error-500, solid;\n\n    * {\n      color: $error-300;\n    }\n  }\n}\n\n@mixin mobile {\n  @media only screen and (max-width: #{$mobile-width}px) {\n    @content;\n  }\n}\n\n@mixin laptop {\n  @media only screen and (max-width: #{$laptop-width}px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: #{$tablet-width}px) {\n    @content;\n  }\n}\n\n@mixin hd {\n  @media only screen and (max-width: #{$hd-width}px) {\n    @content;\n  }\n}\n\n@mixin hd-plus {\n  @media only screen and (min-width: #{$hd-width}px) {\n    @content;\n  }\n}","$font-title: \"Vivl Rail\", sans-serif;\n$font-text: \"Roboto\", sans-serif;\n\n$gray-20: #f9f9fa;\n$gray-25: #fcfcfd;\n$gray-50: #f9fafb;\n$gray-100: #f2f4f7;\n$gray-200: #eaecf0;\n$gray-300: #d0d5dd;\n$gray-400: #98a2b3;\n$gray-500: #667085;\n$gray-600: #475467;\n$gray-700: #344054;\n$gray-800: #1d2939;\n$gray-900: #101828;\n$gray-950: #0C111D;\n\n$main: #47C4F0;\n\n$error-50: #FEF3F2;\n$error-100: #FEE4E2;\n$error-200: #FECDCA;\n$error-300: #FDA29B;\n$error-400: #F97066;\n$error-500: #F04438;\n$error-600: #D92D20;\n\n$green: #17B26A;\n$red: #F04438;\n$orange: #F79009;\n\n$success: $green;\n$error: $red;\n$warning: $orange;\n\n$black: $gray-900;\n$white: #ffffff;\n$text-gray: $gray-500;\n$text-color: #2c2d2e;\n$text-color-secondary: $text-gray;\n$border: $gray-300;\n\n$mobile-width: 700;\n$tablet-width: 1024;\n$laptop-width: 1440;\n$hd: 1680;\n$hd-width: 1920;\n\n$main-container: 1824;\n\n$tr: 0.2s ease-out;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__Q07-B`,
	"title": `style_title__J-xgU`,
	"content": `style_content__T6BSg`,
	"text": `style_text__n+4da`,
	"image": `style_image__rZC0D`
};
export default ___CSS_LOADER_EXPORT___;
